/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starts_TomorrowInputs */

const th_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มพรุ่งนี้`)
};

const en_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starts tomorrow`)
};

const ja_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明日開始`)
};

const zh_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明天开始`)
};

const es_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza mañana`)
};

const pt_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começa amanhã`)
};

const id_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai besok`)
};

const fr_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commence demain`)
};

const tl_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Magsisimula bukas`)
};

const vi_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu ngày mai`)
};

const ko_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`내일 시작`)
};

const de_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beginnt morgen`)
};

const ru_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начинается завтра`)
};

const tr_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yarın başlıyor`)
};

const it_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia domani`)
};

const pl_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaczyna się jutro`)
};

const uk_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Починається завтра`)
};

const hi_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कल शुरू`)
};

const ar_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يبدأ غدًا`)
};

const ms_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermula esok`)
};

const bn_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাল শুরু`)
};

const zh_tw2_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明天開始`)
};

const zh_hk2_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`明天開始`)
};

const ur_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کل شروع`)
};

const fa_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فردا آغاز می‌شود`)
};

const sw_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inaanza kesho`)
};

const nl_starts_tomorrow = /** @type {(inputs: Starts_TomorrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begint morgen`)
};

/**
* | output |
* | --- |
* | "Starts tomorrow" |
*
* @param {Starts_TomorrowInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const starts_tomorrow = /** @type {((inputs?: Starts_TomorrowInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starts_TomorrowInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_starts_tomorrow(inputs)
	if (locale === "ja") return ja_starts_tomorrow(inputs)
	if (locale === "zh") return zh_starts_tomorrow(inputs)
	if (locale === "es") return es_starts_tomorrow(inputs)
	if (locale === "pt") return pt_starts_tomorrow(inputs)
	if (locale === "id") return id_starts_tomorrow(inputs)
	if (locale === "fr") return fr_starts_tomorrow(inputs)
	if (locale === "tl") return tl_starts_tomorrow(inputs)
	if (locale === "vi") return vi_starts_tomorrow(inputs)
	if (locale === "ko") return ko_starts_tomorrow(inputs)
	if (locale === "de") return de_starts_tomorrow(inputs)
	if (locale === "ru") return ru_starts_tomorrow(inputs)
	if (locale === "tr") return tr_starts_tomorrow(inputs)
	if (locale === "it") return it_starts_tomorrow(inputs)
	if (locale === "pl") return pl_starts_tomorrow(inputs)
	if (locale === "uk") return uk_starts_tomorrow(inputs)
	if (locale === "hi") return hi_starts_tomorrow(inputs)
	if (locale === "ar") return ar_starts_tomorrow(inputs)
	if (locale === "ms") return ms_starts_tomorrow(inputs)
	if (locale === "bn") return bn_starts_tomorrow(inputs)
	if (locale === "zh-TW") return zh_tw2_starts_tomorrow(inputs)
	if (locale === "zh-HK") return zh_hk2_starts_tomorrow(inputs)
	if (locale === "ur") return ur_starts_tomorrow(inputs)
	if (locale === "fa") return fa_starts_tomorrow(inputs)
	if (locale === "sw") return sw_starts_tomorrow(inputs)
	if (locale === "nl") return nl_starts_tomorrow(inputs)
	return en_starts_tomorrow(inputs)
});